import React from 'react';
import { ThemeProvider } from 'styled-components';

/* For legacy reasons having to do with how we customized our website for
 * health systems' whitelabeled Zocdoc-powered appointment booking sites,
 * we allow customizing the photo size using the styled-components Theme.
 * However, we also have lots of different use cases in different components
 * on the Zocdoc-branded experience where we want to dynamically set different
 * photo sizes, and we don't want to have to render a ThemeProvider everywhere
 * for that, so here we take size as a prop and just render a themeprovider if
 * it is provided to override whatever is in the standard theme so that the actual
 * image component has a consistent way to figure out what size it is expected
 * to render with.
 */
const MaybeOverrideTheme = ({ children, size }) => {
    return size ? (
        <ThemeProvider
            data-test="doctor-photo-theme-provider"
            theme={{ photo: { size } }}
        >
            {children}
        </ThemeProvider>
    ) : (
        <>{children}</>
    );
};

export default MaybeOverrideTheme;
